import { render, staticRenderFns } from "./treeTablec.vue?vue&type=template&id=2ccb9f26&scoped=true&"
import script from "./treeTablec.vue?vue&type=script&lang=js&"
export * from "./treeTablec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb9f26",
  null
  
)

export default component.exports